import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import NavSectionButton from 'components/NavSection/NavSectionButton';
import { useLocation } from 'react-router-dom';

interface Props {
  materialId: string;
}

const MaterialNavSection = observer(({ materialId }: Props) => {
  const location = useLocation();
  const currentPath = `${location.pathname}${location.search}`;
  const { t } = useTranslation('material');

  return (
    <>
      <NavSectionButton
        icon="icon_single-content-02_16"
        label={t('subMenu.overview')}
        routePath={`/material/overview?materialId=${materialId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_data-table_16"
        label={t('subMenu.baseData')}
        routePath={`/material/detail?materialId=${materialId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_bulb-62_16"
        label={t('subMenu.knowledge')}
        routePath={`/material/content?materialId=${materialId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_globe_16"
        label={t('subMenu.globalFunctions')}
        routePath={`/material/functions?materialId=${materialId}`}
        currentPath={currentPath}
      />
      <NavSectionButton
        icon="icon_pin-3_16"
        label={t('subMenu.locations')}
        routePath={`/material/locations?materialId=${materialId}`}
        currentPath={currentPath}
      />
    </>
  );
});

export default MaterialNavSection;
